import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <p class="italic text-center mb-3">
      Сонет, написанный в подражание тысячам<br/>
      сонетов XVII века о «жестокой», <br/>
      которая почему-то не любит автора
    </p>

    <div class="poem">
      <p class="poem-block mb-3">
        «О горе, я Лаиной не любим!», –<br/>
        Облезлый воздыхатель восклицает, <br/>
        Пуская слюни, весь от страсти тает,<br/>
        И с щёк его, растаяв, каплет грим.
      </p>
    
      <p class="poem-block mb-3">
        Она же, отвращением одним<br/>
        Полна, ему отказом отвечает,<br/>
        Но он её к кровати увлекает,<br/>
        И вот она уже лежит под ним.
      </p>
        
      <p class="poem-block mb-3">
        Плешивый и паршивый, но мужчина!<br/>
        Сильнее он! И тут её рука<br/>
        Нащупала остаток лоскутка, 
      </p>
        
    
      <p class="poem-block mb-3">
        Что был когда-то знаком его чина,<br/>
        И тряпочкой бесстыдно помахала.<br/>
        Увы! Но тряпка трубкою не стала.
      </p>
    </div>
    `
  )
}

const itemName = {
  rus: 'Сонет "о жестокой"'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;